import { SiteItemData, SiteVideoData } from "../../../../interfaces";

interface NewYnetTvVerticalDynamicMutamItemProps {
    videoItem: SiteItemData
    videoIndex: number
    currentPromoIndex: number
    isPromoCarouselInView: boolean
    onVideoEnded: () => void
    onOpenVideoGalleryView: (e) => void
    pushGA4Event: (action: string, isFeedDisplay: boolean) => void
}

interface NewYnetTvVerticalDynamicMutamItemState {
    isVideoReady: boolean
}

export class NewYnetTvVerticalDynamicMutamItem extends React.Component<NewYnetTvVerticalDynamicMutamItemProps, NewYnetTvVerticalDynamicMutamItemState>{
    constructor(props) {
        super(props);
        this.state = {
            isVideoReady: false
        }
    }

    private videoRef;

    componentDidUpdate(prevProps: NewYnetTvVerticalDynamicMutamItemProps) {
        const { videoIndex, currentPromoIndex } = this.props;

        if (currentPromoIndex !== prevProps.currentPromoIndex && currentPromoIndex === videoIndex) {
            if (this.videoRef) {
                const videoElement = document.getElementById(`newYnetTvVerticalItem_${videoIndex}`);
                const videoRect = videoElement.getBoundingClientRect();
                const containerElement = document.querySelector(".videoGalleryVerticalMutamWrapper .frame_forList");
                const containerRect = containerElement.getBoundingClientRect();


                if (videoRect.left < containerRect.left || videoRect.right > containerRect.right) {
                    const scrollElement = document.querySelector(".videoGalleryVerticalMutamWrapper .slotListWrapper");
                    scrollElement.scrollBy({ behavior: 'smooth', left: videoRect.left - containerRect.left - 15 });
                }
            }
        }
    }

    private handleVideoCanPlay = () => {
        this.setState({ isVideoReady: true });
    };

    private secondsToMinutesHandler = (seconds: number) => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
        const newSeconds = (seconds % 60).toString().padStart(2, "0");
        return `${minutes}:${newSeconds}`;
    }

    private onVideoError = () => {
        console.error("Video failed to load");
        this.props.onVideoEnded();
    }

    public render() {
        const { isVideoReady } = this.state;
        const { videoItem, onOpenVideoGalleryView, videoIndex, onVideoEnded, currentPromoIndex, isPromoCarouselInView } = this.props;
        const { media, title } = videoItem;
        const { duration, poster, promoPath } = media as SiteVideoData;
        const shouldDisplayPromo = isPromoCarouselInView && promoPath && currentPromoIndex === videoIndex;
        const slotClasses = `slotView ${shouldDisplayPromo ? "active" : ""}`;

        return (
            <div className={slotClasses} id={`newYnetTvVerticalItem_${videoIndex}`} onClick={() => onOpenVideoGalleryView(videoIndex)}>
                <div className="mediaWrapper">
                    {shouldDisplayPromo &&
                        <video
                            muted
                            playsInline
                            loop={false}
                            autoPlay={true}
                            poster={poster}
                            src={promoPath}
                            webkit-playsInline
                            className="promoVideo"
                            onEnded={onVideoEnded}
                            onError={this.onVideoError}
                            ref={ref => this.videoRef = ref}
                            onCanPlay={this.handleVideoCanPlay}
                        >
                        </video>
                    }
                    
                    <img className={`poster ${isVideoReady ? "fade-out" : "fade-in"}`} src={poster} alt="" />
                </div>

                <div className="contentDiv">
                    <div className="videoTitle" dangerouslySetInnerHTML={{ __html: title }} />

                    <div className="videoDuration">
                        <span>{this.secondsToMinutesHandler(Math.round(duration))}</span>
                        <span className="durationLogo"></span>
                    </div>
                </div>
            </div>
        )
    }
}
